import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { environment } from '@env/environment';

const STAGING_ENV = 'staging';
const DEV_ENV = 'dev';
const STAGING_DOMAIN = 'staging.k8s.wizbii.us';
const DEV_DOMAIN = 'dev.k8s.wizbii.us';

type Env = typeof STAGING_ENV | typeof DEV_ENV | undefined;
type Domain = typeof STAGING_DOMAIN | typeof DEV_DOMAIN;

const ENV_MAP: Record<Domain, Env> = {
  [STAGING_DOMAIN]: STAGING_ENV,
  [DEV_DOMAIN]: DEV_ENV,
} as const;

@Component({
  selector: 'app-version',
  template: `
    <!-- eslint-disable @angular-eslint/template/no-call-expression -->

    <p class="paragraph">
      <mark>v {{ version }}</mark>
      @if (apiEnv(); as apiEnv) {
        <mark [class.orange]="!apiEnv.sameEnv">API: {{ apiEnv.env }}</mark>
      }
    </p>
  `,
  styles: [
    `
      :host {
        background-color: var(--wzb-bo-primary);
        color: white;
        padding-inline: 1rem;
        border-top-left-radius: 10px;

        .paragraph {
          border: 1px solid;
          border-radius: 10px;
          margin: 3px;
          padding: 4px 0;
        }

        mark {
          display: block;
          font-size: small;
          color: white;
          background-color: transparent;
          font-weight: 600;

          &.orange {
            color: var(--wzb-bo-yellow);
          }
        }
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VersionComponent {
  readonly version = environment.version;

  readonly apiEnv = computed(() => {
    let apiEnv: Env = undefined;

    if (environment.api.domain.includes(STAGING_DOMAIN)) {
      apiEnv = ENV_MAP[STAGING_DOMAIN];
    }
    if (environment.api.domain.includes(DEV_DOMAIN)) {
      apiEnv = ENV_MAP[DEV_DOMAIN];
    }

    if (window.location.origin.includes('localhost')) {
      return { env: apiEnv, sameEnv: false };
    }

    let env: Env = undefined;

    if (window.location.origin.includes(STAGING_DOMAIN)) {
      env = ENV_MAP[STAGING_DOMAIN];
    }

    if (window.location.origin.includes(DEV_DOMAIN)) {
      env = ENV_MAP[DEV_DOMAIN];
    }

    const sameEnv = apiEnv === env;

    if (env === undefined || apiEnv === undefined) {
      return;
    }

    return { env, sameEnv };
  });
}
